

<div class="row">
  <div class="col-sm-12 col-xs-12">
    <span (click)="goBack()" class="back-button">
      <i class="material-icons">arrow_back_ios_new</i>
      <span>{{language.ATRAS}}</span>
    </span>
  </div>
  <div class="col-sm-8 col-xs-12 detail-container-responsive" [ngClass]="{'load-animate': loadingDetails}">
    <div class="title-detail" *ngIf="!!currentDetalle">
      <span *ngIf="!loadingDetails && !groupByBundle">{{language.SLAB_NUMBER_TITLE}} {{currentDetalle.ID}} ({{currentDetalleIndex + 1}}/{{detalles.length}})</span>
      <span *ngIf="!loadingDetails && groupByBundle">{{language.PAQUETE_TITLE}} {{currentDetalle.GRUPO}} ({{currentDetalleIndex + 1}}/{{detalles.length}})</span>
      <span *ngIf="loadingDetails">{{language.CARGANDO}}</span>
    </div>
    <gallery *ngIf="!loadingDetails" class="detail-gallery" (itemClick)="expand()" (indexChange)="galleryIndexChange($event)" [items]="imgs" [counter]="false" 
    [nav]="true" [thumb]="false"  thumbPosition="left"></gallery>
  </div>
  <div class="col-sm-4 col-xs-12 detail-container-responsive detail-table" [ngClass]="{'load-animate': loadingDetails}">
    <div class="title-detail" *ngIf="!!currentDetalle" style="padding-bottom: 6px;">
      <span *ngIf="!loadingDetails">{{getNombreMaterial(currentDetalle.MATERIAL)}} <br /> {{language.BLOQUE_TEXT}} {{currentDetalle.BLOQUE}}</span>
    </div>
    <div class="table-separator"></div>
    <table class="table-detail" [ngClass]="{'load-animate': loadingDetails || loadingMaestros}">
      <tr class="padding">
        <td>
          <span>{{language.ACBABADO_DELTALLE_TITLE}}</span>
        </td>
        <td class="description" *ngIf="!!currentDetalle && !loadingDetails">
          <span>{{getAcabadoMaterial(currentDetalle.ACABADO)}}</span>
        </td>
      </tr> 
      <tr class="padding">
        <td>
          <span>{{language.TIPO_MATERIAL_DELTALLE_TITLE}}</span>
        </td>
        <td class="description" *ngIf="!!currentDetalle && !loadingDetails">
          <span>{{getNombreTipoMaterial(currentDetalle.MATERIAL)}}</span>
        </td>
      </tr>     
    </table>
    <div class="table-separator"></div>
    <table>
      <tr class="padding">
        <td>
          <span>{{language.DISPONIBILIDAD_FILTER_TITLE}}</span>
        </td>
        <td class="description" *ngIf="!!currentDetalle && !loadingDetails">
          <span>{{getDisponibilidad(currentDetalle.DISPONIBILIDAD)}}</span>
        </td>
      </tr>
      <tr class="padding">
        <td>
          <span>{{language.COLOR_MATERIAL_DELTALLE_TITLE}}</span>
        </td>
        <td class="description" *ngIf="!!currentDetalle && !loadingDetails">
          <span>{{getColorMaterial(currentDetalle.MATERIAL)}}</span>
        </td>
      </tr>      
    </table>
    <div class="table-separator"></div>
    <table>
      <tr class="padding" *ngIf="!!currentDetalle && !loadingDetails">
        <td>
          <span *ngIf="currentDetalle.MAXLARGO != currentDetalle.MINLARGO">{{language.RANGO_ANCHO_DELTALLE_TITLE}}</span>
          <span *ngIf="currentDetalle.MAXLARGO == currentDetalle.MINLARGO">{{language.ANCHO_MATERIAL_TITLE}}</span>
        </td>
        <td class="description" *ngIf="!!currentDetalle && !loadingDetails">
          <span *ngIf="currentDetalle.MAXLARGO != currentDetalle.MINLARGO">{{getMedida(currentDetalle.MINLARGO) + ' - ' + getMedida(currentDetalle.MAXLARGO) + getUnidadLanguage()}}</span>
          <span *ngIf="currentDetalle.MAXLARGO == currentDetalle.MINLARGO">{{getMedida(currentDetalle.LARGO) + getUnidadLanguage()}}</span>
        </td>
      </tr>
      <tr class="padding" *ngIf="!!currentDetalle && !loadingDetails">
        <td>
          <span *ngIf="currentDetalle.MAXALTO != currentDetalle.MINALTO">{{language.RANGO_ALTO_DELTALLE_TITLE}}</span>
          <span *ngIf="currentDetalle.MAXALTO == currentDetalle.MINALTO">{{language.ALTO_MATERIAL_TITLE}}</span>
        </td>
        <td class="description" *ngIf="!!currentDetalle && !loadingDetails">
          <span *ngIf="currentDetalle.MAXALTO != currentDetalle.MINALTO">{{getMedida(currentDetalle.MINALTO) + ' - ' + getMedida(currentDetalle.MAXALTO) + getUnidadLanguage()}}</span>
          <span *ngIf="currentDetalle.MAXALTO == currentDetalle.MINALTO">{{getMedida(currentDetalle.ALTO) + getUnidadLanguage()}}</span>
        </td>
      </tr>
      <tr class="padding">
        <td>
          <span>{{language.ESPESOR_MATERIAL_DELTALLE_TITLE}}</span>
        </td>
        <td class="description" *ngIf="!!currentDetalle && !loadingDetails">
          <span>{{getEspesor(currentDetalle.ANCHO)}}</span>
        </td>
      </tr>
    </table>
    <div class="table-separator"></div>
    <table>
      <tr class="padding">
        <td>
          <span>{{language.PIEZAS_DELTALLE_TITLE}}</span>
        </td>
        <td class="description" *ngIf="!!currentDetalle && !loadingDetails">
          <span>{{getPiezas(currentDetalle.PIEZAS)}}</span>
        </td>
      </tr>
    </table>
    <div class="table-separator"></div>
    <!-- 
    <table><tr class="padding">
        <td>
          <span>{{language.PIEZAS_DELTALLE_TITLE}}</span>
        </td>
        <td class="description" *ngIf="!!currentDetalle">
          <span>{{getPiezas(currentDetalle.PIEZAS)}}</span>
        </td>
      </tr>
      <tr class="padding">
        <td class="table-details">
          <span>{{language.NUMERO_LOTE}}</span>
        </td>
        <td class="table-details" *ngIf="!!currentDetalle">
          <span>{{currentDetalle.ID}}</span>
        </td>
      </tr> 
    </table>-->
    <br>
    <div *ngIf="!loadingDetails" class="row row-logo" [ngClass]="{'load-animate': loadingDetails}" style="margin: 0px;">
      <div *ngIf="!!currentDetalle && currentDetalle.FICHATECNICA != null && currentDetalle.FICHATECNICA != ''" class="col-sm-12 col-xs-12 detail-container-responsive">
        <div class="container-logo" id="ficha-tecnica">
          <a  class="button-datasheet" [href]="currentDetalle.FICHATECNICA" target="_blank">{{language.FICHA_DATOS}}</a>
        </div>
      </div>
        <div *ngIf="currentDetalle && currentDetalle.LIBRO == '1' && currentDetalle.GRUPO != '' && currentDetalle.GRUPO != null"
          class="col-sm-12 col-xs-12 detail-container-responsive bookmatch-container">
          <div class="icon-bookmatch">
            <img src="assets/img-svg/icons/libro-1.svg" alt="">
          </div>
          <button (click)="bookmatch()" class="button-bookmatch"><span>{{language.VER_BOOKMATCH}}</span></button>
        </div>
    </div>
  </div>
  <div class="col-sm-12 col-xs-12 detail-container-responsive" [ngClass]="{'load-animate': loadingDetails || loadingMaestros}">
    <div class="new-icon-container" *ngIf="!!currentDetalle && !loadingDetails">
      <div class="new-icon" *ngIf="currentDetalle.LIBRO == '1'">
        <img src="assets/img-svg/icons/libro-1.svg">
        <span>Bookmatch</span>
      </div>
      <div class="new-icon" *ngFor="let icono of iconos">
        <img [src]="icono.icon">
        <span>{{icono.description}}</span>
      </div>
    </div>
  </div>
</div>
<br>
<br>
<br>
<br>
<div class="row" >
  <div class="col-sm-12 col-xs-12 detail-container-responsive">
    <image-carousel *ngIf="materialesSimilares.length" [ngClass]="{'load-animate': loadingMaterialesSimilares}" [items]="materialesSimilares"></image-carousel>
  </div>
</div>
<div (click)="goBack()" class="back"><img src="assets/img-svg/left-arrow.svg"></div>
